import { Container } from "./Container";
import { getTranslation } from "dictionary";
import { useUserContext } from "context/UserContext";

export function Features() {
  const { language } = useUserContext();

  const features = [
    {
      title: getTranslation("landingpage", "WHATSAPP", language),
      content: getTranslation("landingpage", "WHATSAPP_SUBTITLE", language),
      icon: "images/icons/comentario.png",
      id: 1,
    },
    {
      title: getTranslation("landingpage", "DESING", language),
      content: getTranslation("landingpage", "DESING_SUBTITLE", language),
      icon: "images/icons/pincel.png",
      id: 2,
    },
    {
      title: getTranslation("landingpage", "PHOTO", language),
      content: getTranslation("landingpage", "PHOTO_SUBTITLE", language),
      icon: "images/icons/telefono.png",
      id: 3,
    },
    {
      title: getTranslation("landingpage", "FEATURED", language),
      content: getTranslation("landingpage", "FEATURED_SUBTITLE", language),
      icon: "images/icons/marcador.png",
      id: 4,
    },
    {
      title: getTranslation("landingpage", "PROMOTION", language),
      content: getTranslation("landingpage", "PROMOTION_SUBTITLE", language),
      icon: "images/icons/cupon.png",
      id: 5,
    },
    {
      title: getTranslation("landingpage", "PRODUCT", language),
      content: getTranslation("landingpage", "PRODUCT_SUBTITLE", language),
      icon: "images/icons/anunciar.png",
      id: 6,
    },
  ];

  return (
    <section
      id="features"
      aria-label="What our customers are saying"
      className="bg-slate-50 py-20 sm:py-32"
    >
      <Container>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-display text-3xl tracking-tight text-slate-900 sm:text-4xl">
            {getTranslation("landingpage", "FEATURES", language)}
          </h2>
        </div>
        <ul
          role="list"
          className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:gap-8 lg:mt-20 lg:max-w-none lg:grid-cols-3"
        >
          {features.map((feature) => (
            <li key={feature.id}>
              <ul role="list" className="flex flex-col gap-y-6 sm:gap-y-8">
                <li>
                  <figure className="min-h-[208px] relative rounded-2xl bg-white p-6 shadow-xl shadow-slate-900/10">
                    <div className="flex gap-2 items-center">
                      <div className="h-10 w-10">
                        <img
                          className="w-full"
                          src={feature.icon}
                          alt={feature.title}
                        />
                      </div>
                      <p className="text-lg tracking-tight text-slate-900">
                        {feature.title}
                      </p>
                    </div>
                    <figcaption className="relative mt-6 flex items-center justify-between border-t border-slate-100 pt-6">
                      <div>
                        <div className="font-display text-base text-slate-900 font-light">
                          {feature.content}
                        </div>
                      </div>
                    </figcaption>
                  </figure>
                </li>
              </ul>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
